import { render, staticRenderFns } from "./ReminderDocumentsLayoutEditElectronProperties.vue?vue&type=template&id=637e66a7"
import script from "./ReminderDocumentsLayoutEditElectronProperties.vue?vue&type=script&lang=ts"
export * from "./ReminderDocumentsLayoutEditElectronProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('637e66a7')) {
      api.createRecord('637e66a7', component.options)
    } else {
      api.reload('637e66a7', component.options)
    }
    module.hot.accept("./ReminderDocumentsLayoutEditElectronProperties.vue?vue&type=template&id=637e66a7", function () {
      api.rerender('637e66a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ReminderDocumentsLayoutEditElectronProperties.vue"
export default component.exports